export enum WorkingModel {
  REMOTE = 'remote',
  HYBRID = 'hybrid',
  ON_SITE = 'on-site',
  FIELD_SERVICE = 'field-service',
}
